import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from 'util/IntlMessages';
import { IconButton } from '@material-ui/core';



function UserRolesTable(props) {

  const userRoleList = props.userRoleList;

  console.log('userRoleList ', userRoleList )
  

  return (
    <Paper>
    <div className="flex-auto"> 
    <div className="table-responsive-material">
      <Table>
        <TableHead>
          <TableRow>
           
            <TableCell align="left"><IntlMessages id="user.roles.table.colum.id"/></TableCell>
            <TableCell align="left"><IntlMessages id="user.roles.table.colum.roleName"/></TableCell>
            <TableCell align="right"><IntlMessages id="user.roles.table.colum.process"/></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {userRoleList.map((n,index) => {
            return (
              <TableRow key={n.id} >
                <TableCell  style={{width:"10%"}} padding="checkbox" >{index+1}</TableCell>
            <TableCell align="left" style={{width:"80%"}} padding="none" >{n.name } - {n.inst}
            {(n.inst !== null && n.inst !== "" && n.customDetail !== undefined) && [" ( " , n.customId>0 && ["  ", n.customDetail.name] ," ) "]} 
            {/* { (n.customId !== null && (n.roleId===54 || n.roleId===55 || n.roleId === 56 || n.roleId === 57)) && <IntlMessages id={"journal."+n.customId}/> } */}
            
            </TableCell>
                <TableCell align="right"  style={{width:"10%"}} padding="none" >
                  <IconButton onClick={()=> props.onClickDeleteUserRole(n.id)} color="primary">
                  <i className="zmdi zmdi-delete zmdi-hc-fw"/>

                  </IconButton>
                {/* <Button variant="contained" color="primary" size="small" className="jr-btn m-1" onClick={()=> props.onClickDeleteUserRole(n.id)}>
                </Button> */}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
    </div>
    </Paper>
  );
}


export default UserRolesTable;